var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "price_labels d-none d-xl-block col-md-4" }, [
      _c("p", [_vm._v("Стоимость")]),
      _vm._v(" "),
      _vm.type !== "refund" ? _c("p", [_vm._v("Скидка")]) : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v("Доставка "),
        _vm.recommendedDeliveryPrice !== null &&
        +_vm.recommendedDeliveryPrice !== +_vm.$editNewOrder.delivery_price
          ? _c(
              "span",
              {
                staticClass: "badge badge-warning pointer",
                on: { click: _vm.setDelivery },
              },
              [_vm._v("рек. " + _vm._s(_vm.recommendedDeliveryPrice))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("p", [_vm._v("Ставка курьера")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "price_inputs col-xl-8 col-md-12" }, [
      _vm.divisionHasSubCurrency()
        ? _c("div", [
            _c("div", { staticClass: "input-group" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.getDivisionCurrency()?.currency)),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currencyData.drugPrice,
                    expression: "currencyData.drugPrice",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number", disabled: "" },
                domProps: { value: _vm.currencyData.drugPrice },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.currencyData, "drugPrice", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.getDivisionCurrency()?.currency)),
                ]),
              ]),
              _vm._v(" "),
              _vm.type !== "refund"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currencyData.discount,
                        expression: "currencyData.discount",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      disabled: !_vm.useCurrencyCalculation,
                      type: "number",
                    },
                    domProps: { value: _vm.currencyData.discount },
                    on: {
                      change: function ($event) {
                        return _vm.updatePrice(true)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currencyData,
                          "discount",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.getDivisionCurrency()?.currency)),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currencyData.delivery,
                    expression: "currencyData.delivery",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  disabled: !_vm.useCurrencyCalculation,
                  type: "number",
                },
                domProps: { value: _vm.currencyData.delivery },
                on: {
                  change: function ($event) {
                    return _vm.updatePrice(true)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.currencyData, "delivery", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.getDivisionCurrency()?.currency)),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currencyData.totalPrice,
                    expression: "currencyData.totalPrice",
                  },
                ],
                staticClass: "form-control",
                attrs: { disabled: "", type: "number" },
                domProps: { value: _vm.currencyData.totalPrice },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.currencyData,
                      "totalPrice",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _vm._v(" "),
            !_vm.useCurrencyCalculation
              ? _c("div", { staticClass: "mt-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-outline-info",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.useCurrencyCalculation =
                            !_vm.useCurrencyCalculation
                        },
                      },
                    },
                    [_vm._v("использовать\n          валюту\n        ")]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drugsPrice,
              expression: "drugsPrice",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", disabled: "" },
          domProps: { value: _vm.drugsPrice },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.drugsPrice = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.type !== "refund"
          ? _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$editNewOrder.discount,
                    expression: "$editNewOrder.discount",
                  },
                ],
                staticClass: "form-control",
                attrs: { disabled: _vm.useCurrencyCalculation, type: "number" },
                domProps: { value: _vm.$editNewOrder.discount },
                on: {
                  change: function ($event) {
                    return _vm.updatePrice(true)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.$editNewOrder, "discount", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$editNewOrder.discount_type,
                        expression: "$editNewOrder.discount_type",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.$editNewOrder,
                            "discount_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function ($event) {
                          return _vm.updatePrice(true)
                        },
                      ],
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [_vm._v("руб")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [_vm._v("%")]),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.$editNewOrder.delivery_price,
              expression: "$editNewOrder.delivery_price",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", disabled: _vm.useCurrencyCalculation },
          domProps: { value: _vm.$editNewOrder.delivery_price },
          on: {
            keyup: function ($event) {
              _vm.customDelivery = true
            },
            change: _vm.updatePrice,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.$editNewOrder, "delivery_price", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.$editNewOrder.price,
              expression: "$editNewOrder.price",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", disabled: "" },
          domProps: { value: _vm.$editNewOrder.price },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.$editNewOrder, "price", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.divisionHasSubCurrency() && _vm.useCurrencyCalculation
          ? _c("div", { staticClass: "mt-1" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-outline-info",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.useCurrencyCalculation = !_vm.useCurrencyCalculation
                    },
                  },
                },
                [_vm._v("использовать руб\n        ")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body p-1 flex justify-content-between" },
              [
                _c(
                  "div",
                  [
                    _c("RunnerSalaryRate", {
                      attrs: {
                        rate: _vm.$editNewOrder.extra_options?.salary_rate ?? 0,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                +(_vm.$editNewOrder.extra_options?.salary_rate ?? 0) === 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-xs",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateSalaryRate(0)
                          },
                        },
                      },
                      [_vm._v("сбросить ставку\n            ")]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showSalaryRateOptions
            ? _c("div", { staticClass: "alert alert-info p-1" }, [
                _c("p", [
                  _vm._v("Использовать ставку\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default btn-xs",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateSalaryRate(3)
                        },
                      },
                    },
                    [_vm._v("индивидуальная")]
                  ),
                  _vm._v("\n            ?\n          "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Курьеру будет зачислена полная сумма доставки"),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    false && _vm.localAllowToUseCard && !_vm.noCashPaymentDetails
      ? _c(
          "div",
          { staticClass: "col-md-12 text-left" },
          [
            _c(
              "v-popover",
              {
                attrs: {
                  "auto-hide": true,
                  placement: "left",
                  open: _vm.openPrePaid,
                },
                on: { hide: () => (_vm.openPrePaid = false) },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-xs btn-outline-success",
                    attrs: { type: "button" },
                    on: { click: _vm.downloadCards },
                  },
                  [_vm._v("\n        Реквизиты для предоплаты\n      ")]
                ),
                _vm._v(" "),
                _c("template", { slot: "popover" }, [
                  _c(
                    "div",
                    { staticClass: "p-2" },
                    [
                      _vm.loading
                        ? _c("clip-loader", {
                            staticClass: "text-center",
                            attrs: {
                              loading: true,
                              color: _vm.$constants.LOADING_COLOR,
                              size: "20px",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.loading && _vm.prePaidCards
                        ? [
                            _c("PrePaidSumSelect", {
                              attrs: {
                                cards: _vm.prePaidCards,
                                orderPrice: _vm.$editNewOrder.price,
                                drugsPrice: _vm.$editNewOrder.details.reduce(
                                  (acc, d) => {
                                    acc += d.qty * d.price
                                    return acc
                                  },
                                  0
                                ),
                                selectedCard: _vm.prePaid,
                                disableChange: false,
                              },
                            }),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title: "Сохранить реквизиты к заявке",
                                type: "button",
                                loading: _vm.btnLoading,
                                color: _vm.$constants.PRIMARY_COLOR,
                                onClick: () => _vm.savePrePaid(),
                                className: "btn btn-outline-info btn-xs",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$editNewOrder.pay_method !== 3 &&
    _vm.$editNewOrder.credit_card_id &&
    +_vm.$editNewOrder.price !== +_vm.$editNewOrder.no_cash_price
      ? _c("div", { staticClass: "alert alert-danger w-100 mt-1 mb-0" }, [
          _c("p", [
            _vm._v("Сумма заявки отличается от суммы для оплаты по карте"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Обновите детали для оплаты по карте!")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$editNewOrder.credit_card_id && _vm.noCashPaymentDetails
      ? _c(
          "div",
          {
            class: {
              "col-md-12 mt-1 alert": true,
              "alert-info": _vm.$editNewOrder.pay_method !== 3,
              "alert-success": _vm.$editNewOrder.pay_method === 3,
            },
          },
          [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "Выданы реквизиты - " +
                  _vm._s(
                    _vm.noCashPaymentDetails.user &&
                      _vm.noCashPaymentDetails.user.name
                  ) +
                  "\n      " +
                  _vm._s(_vm.$editNewOrder?.credit_card?.number) +
                  " (" +
                  _vm._s(_vm.printDate(_vm.noCashPaymentDetails.created_at)) +
                  ")\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$editNewOrder.pay_method !== 3 ? "Запрошено" : "Получено"
                ) + " поступление на карту"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.$editNewOrder.no_cash_price))]),
              _vm._v(" "),
              _vm.$editNewOrder.credit_card &&
              _vm.$editNewOrder.credit_card.number
                ? _c("span", [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.printNumber(_vm.$editNewOrder.credit_card.number)
                        ) +
                        ")"
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            +_vm.$editNewOrder.pay_method !== 3
              ? _c("div", { staticClass: "mt-1 mb-1" }, [
                  _c(
                    "div",
                    _vm._l(_vm.$editNewOrder.sms, function (sms) {
                      return _c("p", [
                        _vm._v("SMS "),
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.printDate(sms.created_at || null)) +
                              ")"
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn btn-info btn-xs",
                        attrs: { type: "button" },
                        on: { click: _vm.getSMS },
                      },
                      [_vm._v("\n          управление предоплатой\n        ")]
                    ),
                  ]),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _c(
                            "v-popover",
                            {
                              attrs: {
                                "auto-hide": true,
                                placement: "left",
                                open: _vm.openSMSPop,
                              },
                              on: { hide: () => (_vm.openSMSPop = false) },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-xs btn btn-outline-info btn-xs",
                                  attrs: { type: "button" },
                                  on: { click: _vm.downloadCards },
                                },
                                [
                                  _vm._v(
                                    "\n            Отправить SMS с реквизитами\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("template", { slot: "popover" }, [
                                _c(
                                  "div",
                                  { staticClass: "send_sms_block" },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Номер телефона"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedPhoneForSend,
                                              expression:
                                                "selectedPhoneForSend",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.selectedPhoneForSend = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(
                                          _vm.$editNewOrder.order_phones,
                                          function (p, i) {
                                            return _c(
                                              "option",
                                              { domProps: { value: i } },
                                              [_vm._v(_vm._s(p.phone.phone))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "alert alert-info p-1" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Перенос строки не отображается в SMS"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Сообщение"),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.smsText,
                                            expression: "smsText",
                                          },
                                        ],
                                        staticClass:
                                          "form-control message_input",
                                        domProps: { value: _vm.smsText },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.smsText = $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("LoadingButton", {
                                      attrs: {
                                        title: "Отправить SMS",
                                        type: "button",
                                        loading: _vm.btnPrePaidLoading,
                                        color: _vm.$constants.SUCCESS_COLOR,
                                        onClick: () => {
                                          _vm.sendCardNumber()
                                        },
                                        className:
                                          "btn btn-outline-success btn-xs",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-xs btn btn-outline-success btn-xs",
                              attrs: { type: "button" },
                              on: { click: _vm.getSMS },
                            },
                            [_vm._v("\n          поиск оплаты\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            +_vm.$editNewOrder.pay_method === 3
              ? [
                  _vm._l(_vm.$editNewOrder.paired_sms || [], function (s) {
                    return _c("p", [
                      _c("strong", [_vm._v("SMS")]),
                      _vm._v(": " + _vm._s(s.message)),
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("подтверждено")]),
                    _vm._v(
                      " (" +
                        _vm._s(
                          _vm.printDate(
                            _vm.$editNewOrder.extra_options.pre_paid_date
                          )
                        ) +
                        ")"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$editNewOrder.extra_options.pre_paid_comment)
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.paymentsFiles && _vm.paymentsFiles.length
      ? _c("div", { staticClass: "col-md-12 text-right mb-0" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: { type: "button" },
              on: { click: _vm.openFilesModal },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-file-image-o" }),
              _vm._v(
                "\n      Прикрепленные файлы оплаты\n      (" +
                  _vm._s(_vm.paymentsFiles.length) +
                  ")\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Сумма")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }